import React from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router';

export function RedirectWithState({ to, replace, state }) {
  const { state: locationState } = useLocation();
  return (
    <Navigate
      to={to}
      state={{ ...locationState, ...state }}
      replace={replace}
    />
  );
}

export function useNavigateWithState() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const stateRef = React.useRef(state);

  React.useEffect(() => {
    stateRef.current = state;
  }, [state]);

  return React.useCallback(
    (to, { state: navigateState, replace } = {}) => {
      navigate(to, {
        state: { ...stateRef.current, ...navigateState },
        replace,
      });
    },
    [navigate],
  );
}
